import styled from 'styled-components';
import { detailsBackground, primaryColor } from '../../../../config/colors';

export const Container = styled.div`
  background-color: ${detailsBackground};

  display: flex;
  flex-direction: column;
  padding: 0.5rem 1.5rem;
`;

export const Item = styled.div`
  background-color: white;
  border-radius: 8px;
  display: grid;
  border: 1px solid #f1f1f1;
  grid-template-columns: calc(50px + 2 * 1rem) auto;
  grid-column-gap: 0px;
  margin-top: 1rem;
  height: 100px;
  padding: 1rem;
  position: relative;
`;

export const ItemLeft = styled.div``;

export const ViewerContainer = styled.div`
  width: 64px;
  border-radius: 8px;
  overflow: hidden;
`;

export const ItemRight = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  height: 24px;
  font-size: 0.8rem;
  font-weight: 600;
  margin: 0px;

  line-height: 24px;
  overflow: hidden;
`;

export const SubTitle = styled.h4`
  height: 24px;
  font-size: 0.7rem;

  font-weight: 500;
  margin: 0px;

  line-height: 24px;
`;
